import { render, staticRenderFns } from "./FooterVll.vue?vue&type=template&id=cdcf4e3e&scoped=true&"
import script from "./FooterVll.vue?vue&type=script&lang=js&"
export * from "./FooterVll.vue?vue&type=script&lang=js&"
import style0 from "./FooterVll.vue?vue&type=style&index=0&id=cdcf4e3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcf4e3e",
  null
  
)

export default component.exports